import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './bankInfo.module.scss';
import utils from '../../../utils/utils';
import  { ApiCore } from '../../../api/index';
import methods from '../../../utils/methods';
import { Button } from 'antd-mobile-v5';
import { InputItem } from 'antd-mobile';
import {  Toast } from 'antd-mobile';
const api = new ApiCore();

function BankInfo(props: any) {

    const [isEdit, setIsEdit] = useState(false);
    const [bankNoVisible, setBankNoVisible] = useState(false);
    const [bankInfo, setBankInfo] = useState<any>({});
    const [bankInput, setBankInput] = useState<any>({});

    useEffect(() => {
        document.title = '收款信息';
        initData();
    }, [])

    // 初始化数据
    const initData = () => {
        api.GetCollectionInfo().then((res: any) => {
            if (res.code == '0') {
                res.data && setBankInfo(res.data);
            }
        });
    }

    // 修改信息
    const updateInfo= () => {
        setBankInput(bankInfo);
        setIsEdit(true);
    }

    // 退出修改信息
    const exitUpdateInfo= () => {
        setIsEdit(false);
    }

    // 保存修改信息
    const saveUpdateInfo= () => {
        let _bankNumber = bankInput.bankNumber;
        if (_bankNumber && !methods.isBankCard(_bankNumber) || _bankNumber.length < 12 || _bankNumber.length > 21) {
            Toast.fail('请正确填写银行卡号', 0.8);
            return
        }
        api.UpdateCollectionInfo(bankInput).then((res: any) => {
            if (res.code == 0) {
                setBankInfo(bankInput);
                Toast.success('信息保存成功', 0.8);
            }
            setIsEdit(false);
        })
    }

    // 数据绑定
    const inputOnChange = (val: any, type: string) => {
        if (type === 'account') {
            setBankInput({
                ...bankInput,
                account: val
            });
        } else if (type === 'bankNumber') {
            setBankInput({
                ...bankInput,
                bankNumber: val
            });
        } else if (type === 'bankOfDeposit') {
            setBankInput({
                ...bankInput,
                bankOfDeposit: val
            });
        }
    }


    return (
        <div className={`${styles.bankInfo_content}`}>
            <div className={`${styles.bank_title}`}>收款人信息</div>
            <div className={`${styles.bank_content}`}>
                <div className={`${styles.item_with_line}`}> 
                    <div className={`${styles.item_title}`}>收款人</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{bankInfo.account || '暂未填写'}</div>
                        :
                        <InputItem type='text' autoFocus={true} value={ bankInput.account } onChange={(val) => { inputOnChange(val, 'account') }} />
                    }
                </div>
                <div className={`${styles.item_with_line}`} onClick={ () => { setBankNoVisible(!bankNoVisible); }}> 
                    <div className={`${styles.item_title}`}>银行卡号</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{ !bankNoVisible ? (bankInfo.bankNumber ? bankInfo.bankNumber.substr(0, 4) + "**********" + bankInfo.bankNumber.substr(bankInfo.bankNumber.length - 4) : '暂未填写') : ( bankInfo.bankNumber || '暂未填写') }</div>
                        :
                        <InputItem type='text' value={ bankInput.bankNumber } onChange={(val) => { inputOnChange(val, 'bankNumber') }} />
                    }
                </div>
                <div className={`${styles.item_no_line}`}> 

                    <div className={`${styles.item_title}`}>开户行</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{bankInfo.bankOfDeposit || '暂未填写'}</div>
                        :
                        <InputItem type='text' value={ bankInput.bankOfDeposit } onChange={(val) => { inputOnChange(val, 'bankOfDeposit') }} />
                    }
                </div>
            </div>
            {
                !isEdit ?
                <div className={`${styles.btn_wrap}`}>
                    <Button className={`${styles.update_btn}`} color='primary' onClick={() => { updateInfo() }}>修改信息</Button>
                </div>
                :
                <div className={`${styles.btn_wrap}`}>
                    <Button className={`${styles.update_btn}`} color='primary' fill='outline' onClick={() => { exitUpdateInfo() }}>不保存，退出修改</Button>
                    <Button className={`${styles.update_btn}`} color='primary' onClick={() => { saveUpdateInfo() }}>保存信息</Button>
                </div>
            }
            <div className={`${styles.bank_tip}`}>
                为了保障您的账户安全，此信息只作为医生工作室中个人资料数据。修改信息不会修改已报名活动所提交的个人信息和银行卡信息，感谢您的理解。
            </div>
        </div>
    )

}

export default BankInfo;